export { default } from './AboutCardSecondaryBenefitSlider';
